<script>
    import { fade } from "svelte/transition";
    import { factoryStore } from "../store/factories.js";
    import { langTextStore } from "../store/langtexts.js";

    export let crntHelpTextKeyBase;

    $: helpTitle = $langTextStore.getText(crntHelpTextKeyBase + "-help-title");
    $: helpLong = $langTextStore.getText(crntHelpTextKeyBase + "-help-long");
</script>

<div class="p-5 pl-3 text">
    <svg
        xmlns="http://www.w3.org/2000/svg"
        on:click={() => factoryStore.showSuperHelp(false)}
        onmousedown="return false"
        title="close"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-x-square-fill float-end btn-icon"
        viewBox="0 0 16 16"
    >
        <path
            d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"
        />
    </svg>
    <div style="max-width:500px;">
        <h2 class="highlight text-white">{$factoryStore.superHelpTitle}</h2>
        <br />
        {@html $factoryStore.superHelpLongText}
    </div>
</div>

<style>
    div {
        color: #eee;
    }
</style>
